import {computed, Ref} from 'vue';
import GradingRunDto = App.DTOs.GradingRunDto;

export function useGradingRunData(gradingRun: Ref<GradingRunDto | null | undefined>) {
  const id = computed(() => gradingRun.value?.id || null);
  const taskGrade = computed(() => gradingRun.value?.taskGrade || null);
  const criterionGrades = computed(() => taskGrade.value?.criterionGrades || []);

  return {gradingRun, id, taskGrade, criterionGrades};
}
